import script from "./DropButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropButton.vue?vue&type=script&lang=ts&setup=true"

import "./DropButton.vue?vue&type=style&index=0&id=95ff0468&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95ff0468"]])

export default __exports__